import { ImageField } from "@inmagik/magik-ui"
import { getIn, useFormikContext } from "formik"
import { Col } from "react-bootstrap"
import type { Media } from "../../types"

export default function MediaForm({ col = 8 }: { col?: number }) {
  const { setFieldValue, values, errors, submitCount } = useFormikContext<Media>()

  return (
    <Col xs={col} className="d-flex flex-column align-items-stretch gap-4">
      <ImageField
        label="Immagine"
        layout="horizontal"
        value={values.media_file}
        onChange={(value) => {
          setFieldValue("media_file", value)
        }}
        isValid={submitCount > 0 ? !getIn(errors, "media_file") : undefined}
        errorMessage={getIn(errors, "media_file")}
      />
    </Col>
  )
}
